import React, { useState } from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';
import { BasicFetch } from '../../utils/BasicFetch.ts';
import { driver } from 'driver.js';
import { Reptile } from '../../types/Reptile.ts';


export const SuggestReptileModal = ({ closeModal, onSuccess, currentReptiles, prefill = '' }: {
  closeModal: () => void,
  onSuccess: () => void,
  currentReptiles: Reptile[],
  prefill?: string
}) => {
  const [reptileName, setReptileName] = useState(prefill);
  const [hasBeenWarned, setHasBeenWarned] = useState(false);

  const driverObj = driver({
    steps: [
      { element: '#morph', popover: { title: 'Reptile Species', description: 'Type the species of the reptile you are suggesting. Please check the reptile dropdown on the menu page to verify this animal doesn\'t exist already.', position: 'bottom' } },
      { element: '#submit-reptile-btn', popover: { title: 'Submit', description: 'Submit your reptile suggestion for approval.', position: 'bottom' } },
    ]
  })

  const submitReptile = () => {
    // check if reptile name is similar to any existing reptile
    if (!hasBeenWarned && currentReptiles.some(reptile => reptile.reptile_name.toLowerCase() === reptileName.toLowerCase())) {
      alert("This reptile is already present in RepTool. Please check the reptile dropdown on the menu page to verify.");
      setHasBeenWarned(true);
      return;
    }

    let formData = new FormData();
    formData.append("reptile_name", reptileName);
    BasicFetch({
      url: `${(window as any).serverLocation}reptile/create`,
      contentType: 'multipart/form-data',
      method: 'POST',
      data: formData,
      onSuccess: (data) => {
        if (data.success) {
          window.alert("Reptile was successfully submitted for approval");
          onSuccess()
        }
      },
      onFail: () => {
        window.alert("There was an error, please try again later.")
      }
    });
  }



  return (
    <ReptoolModal id='suggest-reptile-modal' title="Suggest A Reptile" closeModal={() => closeModal(false)} showTutorial={driverObj.drive} body={
      <React.Fragment>
        <div className="mt-3 d-flex flex-column has-validation">
          <h6>Reptile Species:</h6>
          <div className="ui-textinput ui-corner-all ui-shadow-inset ui-textinput-text ui-body-inherit">
            <input id="morph" type="text" value={reptileName} onChange={(event) => setReptileName(event.target.value)} className="w-100 form-control bg-black text-blue rounded" />
            <div className="invalid-feedback">Reptile species required</div>
          </div>
        </div>

        <div className='mt-3 d-flex flex-column'>
          <div id='submit-reptile-btn' onClick={() => submitReptile()} className="btn mt-3 button w-100">Submit Reptile For Approval</div>
        </div>
      </React.Fragment>

    } />
  )
}